import { render, staticRenderFns } from "./liangView.vue?vue&type=template&id=1bcfb816"
import script from "./liangView.vue?vue&type=script&lang=js"
export * from "./liangView.vue?vue&type=script&lang=js"
import style0 from "./liangView.vue?vue&type=style&index=0&id=1bcfb816&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports